import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"
import {Grid as MuiGrid} from "@mui/material"
import {XXL_BREAKPOINT_MAX} from "../../../../../../../config/constants"

export const StyledGridContent = styled(MuiGrid, {
    shouldForwardProp: prop => prop !== "xxlBreakpointEnabled",
})<{xxlBreakpointEnabled: boolean}>`
    color: ${({theme}) => theme.uxfabric.text.primary};
    background: ${({theme}) => theme.uxfabric.components.menu.megaMenu.gutter.backgroundColor};

    @media (min-width: ${breakpoints.values.md}px) {
        display: flex;
        width: 100%;
        max-width: ${breakpoints.values.lg}px;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        width: 100%;
        max-width: ${breakpoints.values.xl}px;
        margin: auto;
        pointer-events: initial;
    }

    ${({xxlBreakpointEnabled}) =>
        xxlBreakpointEnabled &&
        `@media (min-width: ${breakpoints.values.xxl}px) {
            width: 100%;
            max-width: ${XXL_BREAKPOINT_MAX}px;
            margin: auto;
            pointer-events: initial;
        }`}
`
